import { render, staticRenderFns } from "./pageSetting.vue?vue&type=template&id=040f8b1f&scoped=true"
import script from "./pageSetting.vue?vue&type=script&lang=js"
export * from "./pageSetting.vue?vue&type=script&lang=js"
import style0 from "./pageSetting.vue?vue&type=style&index=0&id=040f8b1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040f8b1f",
  null
  
)

export default component.exports